// @ts-nocheck
import React from "react";
import { Field } from "src/components/Forms/Field";
import { FormikInput } from "src/components/Forms/TextInput";

interface Props {}

const Name: React.FC<Props> = () => {
  return (
    <Field label="Name:" mb={26}>
      <FormikInput
        name="name"
        size="middle"
        placeholder="e.g. Joe"
        borderRadius={2}
        borderColor="grey5"
      />
    </Field>
  );
};

export default Name;
